import { createBatchAnimation } from './createBatchAnimation';

export const animateSlideLeft = () => {
  if (!document.querySelector('.animate-slide-left')) {
    return;
  }

  createBatchAnimation({
    selector: '.animate-slide-left',
    initialState: {
      autoAlpha: 0,
      x: window.innerWidth,
    },
    resetState: {
      autoAlpha: 0,
      y: 25,
    },
    checkVisited: true,
  });
};
